// import React, { useState, useRef } from "react";
// import { FaArrowRight } from "react-icons/fa";
// import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";

// const courses = [
//     {
//         title: "Commercial Pilot License (CPL)",
//         left: {
//             title: "10-12 Months - large",
//             subtitle: "Duration - regular",
//             img: "https://images.unsplash.com/photo-1508614999368-9260051291ea?auto=format&fit=crop&w=600&q=80",
//         },
//         right: {
//             title: "Ground School",
//             points: [
//                 "Air Regulation.",
//                 "Meteorology.",
//                 "Navigation.",
//                 "Technical General.",
//                 "RTR.",
//                 "Tech Spec.",
//             ],
//             img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=600&q=80",
//             bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//         },
//         middle: {
//             eligibility: [
//                 "DGCA Class I Medical for issue of CPL License.",
//                 "10th +2 passed with Physics & Maths.",
//                 "17 years of age and above at the time of joining.",
//                 "Adequate competency in the English Language.",
//             ],
//             bottomLeft: {
//                 bg: "https://images.unsplash.com/photo-1485841890310-6a055c88698a?auto=format&fit=crop&w=600&q=80",
//                 text: "Commercial Pilot License (CPL)",
//             },
//             bottomRight: {
//                 bg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
//                 title: "Flying Training",
//                 points: [
//                     "Single engine Flying – 185 Hrs.",
//                     "Multi Engine Flying – 15 Hrs.",
//                     "Simulator- 20 Hrs .",
//                 ],
//             },
//         },
//     },
//     {
//         title: "Private Pilot License (PPL)",
//         left: {
//             title: "6-8 Months - medium",
//             subtitle: "Duration - flexible",
//             img: "https://images.unsplash.com/photo-1518655048521-f130df041f66?auto=format&fit=crop&w=600&q=80",
//         },
//         right: {
//             title: "Ground School",
//             points: ["Air Law.", "Human Performance.", "Flight Planning."],
//             img: "https://images.unsplash.com/photo-1508830524289-0adcbe822b40?auto=format&fit=crop&w=600&q=80",
//             bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//         },
//         middle: {
//             eligibility: [
//                 "DGCA Class II Medical.",
//                 "10th +2 passed in any stream.",
//                 "17 years and above.",
//             ],
//             bottomLeft: {
//                 bg: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
//                 text: "Private Pilot License (PPL)",
//             },
//             bottomRight: {
//                 bg: "https://images.unsplash.com/photo-1499084732479-de2c02d45fc4?auto=format&fit=crop&w=800&q=80",
//                 title: "Flying Training",
//                 points: ["Single engine Flying – 40 Hrs.", "Simulator- 5 Hrs."],
//             },
//         },
//     },
// ];

// const CoursesSection = () => {
//     const [selectedCourse, setSelectedCourse] = useState(courses[0]);
//     const bentoRef = useRef(null);

//     const handleCourseClick = (course) => {
//         setSelectedCourse(course);
//         if (bentoRef.current) {
//             bentoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//     };

//     return (
//         <section className="w-full py-16 bg-white">
//             {/* Header */}
//             <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 px-6">
//                 <div className="w-full lg:w-1/2">
//                     <FadeInSectionDownToUp>
//                         <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//                             Courses That Take You Higher
//                         </h2>
//                     </FadeInSectionDownToUp>
//                     <FadeInSectionDownToUp>
//                         <p className="text-gray-600 text-lg leading-relaxed">
//                             Explore our professional pilot training programs designed to take
//                             you from first flight to full certification.
//                         </p>
//                     </FadeInSectionDownToUp>
//                 </div>
//                 <div className="w-full lg:w-1/2 flex items-center justify-center">
//                     <div className="relative w-full flex items-center">
//                         <div className="border-t-2 border-dotted border-gray-400 w-full"></div>
//                         <FaArrowRight className="absolute right-0 text-[#FF6557] text-2xl" />
//                     </div>
//                 </div>
//             </div>

//             {/* Course Selector */}
//             <div className="py-12 px-6 bg-cover bg-center mx-5 rounded-3xl"
//                 style={{
//                     backgroundImage:
//                         "url('https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80')",
//                 }}
//             >
//                 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//                     {courses.map((course, index) => (
//                         <FadeInSectionDownToUp key={index}>
//                             <div
//                                 onClick={() => handleCourseClick(course)}
//                                 className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full hover:scale-105 transition-transform duration-300 cursor-pointer"
//                             >
//                                 <img
//                                     src={course.left.img}
//                                     alt={course.title}
//                                     className="w-full h-40 object-cover"
//                                 />
//                                 <div className="p-4 flex-grow flex items-center justify-center">
//                                     <h3 className="text-lg font-semibold text-center text-gray-800">
//                                         {course.title}
//                                     </h3>
//                                 </div>
//                             </div>
//                         </FadeInSectionDownToUp>
//                     ))}
//                 </div>
//             </div>

//             {/* Bento Grid */}
//             <div ref={bentoRef} className="container mx-auto px-6 py-12">
//                 <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//                     {/* Left */}
//                     <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between">
//                         <div>
//                             <h3 className="text-xl font-bold text-gray-800 mb-2">
//                                 {selectedCourse.left.title}
//                             </h3>
//                             <p className="text-gray-600">{selectedCourse.left.subtitle}</p>
//                         </div>
//                         <img
//                             src={selectedCourse.left.img}
//                             alt="left"
//                             className="mt-4 rounded-lg object-cover w-full h-40"
//                         />
//                     </div>

//                     {/* Middle */}
//                     <div className="flex flex-col gap-6">
//                         {/* Top */}
//                         <div className="bg-white rounded-xl shadow-lg p-6">
//                             <h3 className="text-xl font-bold text-gray-800 mb-4">Eligibility</h3>
//                             <ul className="list-disc list-inside space-y-2 text-gray-600">
//                                 {selectedCourse.middle.eligibility.map((item, idx) => (
//                                     <li key={idx}>{item}</li>
//                                 ))}
//                             </ul>
//                         </div>
//                         {/* Bottom */}
//                         <div className="grid grid-cols-4 gap-6 h-full">
//                             {/* 25% */}
//                             <div
//                                 className="col-span-1 bg-cover bg-center rounded-xl flex items-center justify-center text-white font-bold text-center p-4"
//                                 style={{ backgroundImage: `url(${selectedCourse.middle.bottomLeft.bg})` }}
//                             >
//                                 {selectedCourse.middle.bottomLeft.text}
//                             </div>
//                             {/* 75% */}
//                             <div
//                                 className="col-span-3 bg-cover bg-center rounded-xl p-6 text-white flex flex-col justify-between"
//                                 style={{ backgroundImage: `url(${selectedCourse.middle.bottomRight.bg})` }}
//                             >
//                                 <h3 className="text-lg font-bold mb-3">
//                                     {selectedCourse.middle.bottomRight.title}
//                                 </h3>
//                                 <ul className="list-disc list-inside space-y-1">
//                                     {selectedCourse.middle.bottomRight.points.map((p, i) => (
//                                         <li key={i}>{p}</li>
//                                     ))}
//                                 </ul>
//                             </div>
//                         </div>
//                     </div>

//                     {/* Right */}
//                     <div
//                         className="rounded-xl shadow-lg p-6 text-white flex flex-col justify-between bg-cover bg-center"
//                         style={{ backgroundImage: `url(${selectedCourse.right.bg})` }}
//                     >
//                         <div>
//                             <h3 className="text-2xl font-bold mb-4">
//                                 {selectedCourse.right.title}
//                             </h3>
//                             <ul className="list-disc list-inside space-y-2">
//                                 {selectedCourse.right.points.map((item, idx) => (
//                                     <li key={idx}>{item}</li>
//                                 ))}
//                             </ul>
//                         </div>
//                         <img
//                             src={selectedCourse.right.img}
//                             alt="right"
//                             className="mt-4 rounded-lg object-cover w-full h-32"
//                         />
//                     </div>
//                 </div>
//             </div>
//         </section>
//     );
// };

// export default CoursesSection;




// import React, { useState, useRef } from "react";
// import { FaArrowRight } from "react-icons/fa";
// import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";

// const courses = [
//   {
//     title: "Commercial Pilot License (CPL)",
//     left: {
//       title: "10-12 Months - large",
//       subtitle: "Duration - regular",
//       img: "https://images.unsplash.com/photo-1508614999368-9260051291ea?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: [
//         "Air Regulation.",
//         "Meteorology.",
//         "Navigation.",
//         "Technical General.",
//         "RTR.",
//         "Tech Spec.",
//       ],
//       img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class I Medical for issue of CPL License.",
//         "10th +2 passed with Physics & Maths.",
//         "17 years of age and above at the time of joining.",
//         "Adequate competency in the English Language.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1485841890310-6a055c88698a?auto=format&fit=crop&w=600&q=80",
//         text: "Commercial Pilot License (CPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: [
//           "Single engine Flying – 185 Hrs.",
//           "Multi Engine Flying – 15 Hrs.",
//           "Simulator- 20 Hrs .",
//         ],
//       },
//     },
//   },
//   {
//     title: "Private Pilot License (PPL)",
//     left: {
//       title: "6-8 Months - medium",
//       subtitle: "Duration - flexible",
//       img: "https://images.unsplash.com/photo-1518655048521-f130df041f66?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: ["Air Law.", "Human Performance.", "Flight Planning."],
//       img: "https://images.unsplash.com/photo-1508830524289-0adcbe822b40?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class II Medical.",
//         "10th +2 passed in any stream.",
//         "17 years and above.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
//         text: "Private Pilot License (PPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1499084732479-de2c02d45fc4?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: ["Single engine Flying – 40 Hrs.", "Simulator- 5 Hrs."],
//       },
//     },
//   },
// ];

// const CoursesSection = () => {
//   const [selectedCourse, setSelectedCourse] = useState(courses[0]);
//   const [showModal, setShowModal] = useState(false);
//   const bentoRef = useRef(null);

//   const handleCourseClick = (course) => {
//     setSelectedCourse(course);
//     if (window.innerWidth < 1024) {
//       // Mobile & tablet → open modal
//       setShowModal(true);
//     } else {
//       // Desktop → scroll to bento
//       if (bentoRef.current) {
//         bentoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }
//   };

//   return (
//     <section className="w-full py-16 bg-white">
//       {/* Header */}
//       <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 px-6">
//         <div className="w-full lg:w-1/2">
//           <FadeInSectionDownToUp>
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Courses That Take You Higher
//             </h2>
//           </FadeInSectionDownToUp>
//           <FadeInSectionDownToUp>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               Explore our professional pilot training programs designed to take
//               you from first flight to full certification.
//             </p>
//           </FadeInSectionDownToUp>
//         </div>
//         <div className="w-full lg:w-1/2 flex items-center justify-center">
//           <div className="relative w-full flex items-center">
//             <div className="border-t-2 border-dotted border-gray-400 w-full"></div>
//             <FaArrowRight className="absolute right-0 text-[#FF6557] text-2xl" />
//           </div>
//         </div>
//       </div>

//       {/* Course Selector */}
//       <div
//         className="py-12 px-6 bg-cover bg-center mx-5 rounded-3xl"
//         style={{
//           backgroundImage:
//             "url('https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80')",
//         }}
//       >
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {courses.map((course, index) => (
//             <FadeInSectionDownToUp key={index}>
//               <div
//                 onClick={() => handleCourseClick(course)}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full hover:scale-105 transition-transform duration-300 cursor-pointer"
//               >
//                 <img
//                   src={course.left.img}
//                   alt={course.title}
//                   className="w-full h-40 object-cover"
//                 />
//                 <div className="p-4 flex-grow flex items-center justify-center">
//                   <h3 className="text-lg font-semibold text-center text-gray-800">
//                     {course.title}
//                   </h3>
//                 </div>
//               </div>
//             </FadeInSectionDownToUp>
//           ))}
//         </div>
//       </div>

//       {/* Bento Grid (Desktop only) */}
//       <div
//         ref={bentoRef}
//         className="container mx-auto px-6 py-12 hidden lg:block"
//       >
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           {/* Left */}
//           <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between">
//             <div>
//               <h3 className="text-xl font-bold text-gray-800 mb-2">
//                 {selectedCourse.left.title}
//               </h3>
//               <p className="text-gray-600">{selectedCourse.left.subtitle}</p>
//             </div>
//             <img
//               src={selectedCourse.left.img}
//               alt="left"
//               className="mt-4 rounded-lg object-cover w-full h-40"
//             />
//           </div>

//           {/* Middle */}
//           <div className="flex flex-col gap-6">
//             {/* Top */}
//             <div className="bg-white rounded-xl shadow-lg p-6">
//               <h3 className="text-xl font-bold text-gray-800 mb-4">
//                 Eligibility
//               </h3>
//               <ul className="list-disc list-inside space-y-2 text-gray-600">
//                 {selectedCourse.middle.eligibility.map((item, idx) => (
//                   <li key={idx}>{item}</li>
//                 ))}
//               </ul>
//             </div>
//             {/* Bottom */}
//             <div className="grid grid-cols-4 gap-6 h-full">
//               {/* 25% */}
//               <div
//                 className="col-span-1 bg-cover bg-center rounded-xl flex items-center justify-center text-white font-bold text-center p-4"
//                 style={{
//                   backgroundImage: `url(${selectedCourse.middle.bottomLeft.bg})`,
//                 }}
//               >
//                 {selectedCourse.middle.bottomLeft.text}
//               </div>
//               {/* 75% */}
//               <div
//                 className="col-span-3 bg-cover bg-center rounded-xl p-6 text-white flex flex-col justify-between"
//                 style={{
//                   backgroundImage: `url(${selectedCourse.middle.bottomRight.bg})`,
//                 }}
//               >
//                 <h3 className="text-lg font-bold mb-3">
//                   {selectedCourse.middle.bottomRight.title}
//                 </h3>
//                 <ul className="list-disc list-inside space-y-1">
//                   {selectedCourse.middle.bottomRight.points.map((p, i) => (
//                     <li key={i}>{p}</li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           </div>

//           {/* Right */}
//           <div
//             className="rounded-xl shadow-lg p-6 text-white flex flex-col justify-between bg-cover bg-center"
//             style={{ backgroundImage: `url(${selectedCourse.right.bg})` }}
//           >
//             <div>
//               <h3 className="text-2xl font-bold mb-4">
//                 {selectedCourse.right.title}
//               </h3>
//               <ul className="list-disc list-inside space-y-2">
//                 {selectedCourse.right.points.map((item, idx) => (
//                   <li key={idx}>{item}</li>
//                 ))}
//               </ul>
//             </div>
//             <img
//               src={selectedCourse.right.img}
//               alt="right"
//               className="mt-4 rounded-lg object-cover w-full h-32"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Modal (Mobile/Tablet) */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4">
//           <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-6 relative">
//             <button
//               className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
//               onClick={() => setShowModal(false)}
//             >
//               ✕
//             </button>
//             <h2 className="text-2xl font-bold mb-4">
//               {selectedCourse.title}
//             </h2>
//             {/* Eligibility */}
//             <div className="mb-6">
//               <h3 className="text-lg font-bold mb-2">Eligibility</h3>
//               <ul className="list-disc list-inside space-y-1 text-gray-700">
//                 {selectedCourse.middle.eligibility.map((item, idx) => (
//                   <li key={idx}>{item}</li>
//                 ))}
//               </ul>
//             </div>
//             {/* Flying Training */}
//             <div className="mb-6">
//               <h3 className="text-lg font-bold mb-2">
//                 {selectedCourse.middle.bottomRight.title}
//               </h3>
//               <ul className="list-disc list-inside space-y-1 text-gray-700">
//                 {selectedCourse.middle.bottomRight.points.map((p, i) => (
//                   <li key={i}>{p}</li>
//                 ))}
//               </ul>
//             </div>
//             {/* Ground School */}
//             <div className="mb-6">
//               <h3 className="text-lg font-bold mb-2">
//                 {selectedCourse.right.title}
//               </h3>
//               <ul className="list-disc list-inside space-y-1 text-gray-700">
//                 {selectedCourse.right.points.map((item, idx) => (
//                   <li key={idx}>{item}</li>
//                 ))}
//               </ul>
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default CoursesSection;




// import React, { useState, useRef } from "react";
// import { FaArrowRight } from "react-icons/fa";
// import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";

// const courses = [
//   {
//     title: "Commercial Pilot License (CPL)",
//     left: {
//       title: "10-12 Months - large",
//       subtitle: "Duration - regular",
//       img: "https://images.unsplash.com/photo-1508614999368-9260051291ea?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: [
//         "Air Regulation.",
//         "Meteorology.",
//         "Navigation.",
//         "Technical General.",
//         "RTR.",
//         "Tech Spec.",
//       ],
//       img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class I Medical for issue of CPL License.",
//         "10th +2 passed with Physics & Maths.",
//         "17 years of age and above at the time of joining.",
//         "Adequate competency in the English Language.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1485841890310-6a055c88698a?auto=format&fit=crop&w=600&q=80",
//         text: "Commercial Pilot License (CPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: [
//           "Single engine Flying – 185 Hrs.",
//           "Multi Engine Flying – 15 Hrs.",
//           "Simulator- 20 Hrs .",
//         ],
//       },
//     },
//   },
//   {
//     title: "Private Pilot License (PPL)",
//     left: {
//       title: "6-8 Months - medium",
//       subtitle: "Duration - flexible",
//       img: "https://images.unsplash.com/photo-1518655048521-f130df041f66?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: ["Air Law.", "Human Performance.", "Flight Planning."],
//       img: "https://images.unsplash.com/photo-1508830524289-0adcbe822b40?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class II Medical.",
//         "10th +2 passed in any stream.",
//         "17 years and above.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
//         text: "Private Pilot License (PPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1499084732479-de2c02d45fc4?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: ["Single engine Flying – 40 Hrs.", "Simulator- 5 Hrs."],
//       },
//     },
//   },
// ];

// const CoursesSection = () => {
//   const [selectedCourse, setSelectedCourse] = useState(courses[0]);
//   const [showModal, setShowModal] = useState(false);
//   const bentoRef = useRef(null);

//   const handleCourseClick = (course) => {
//     setSelectedCourse(course);
//     if (window.innerWidth < 1024) {
//       setShowModal(true); // Mobile/tablet → show modal
//     } else {
//       if (bentoRef.current) {
//         bentoRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
//       }
//     }
//   };

//   // 🔹 Reusable Bento Grid (for desktop + modal)
//   const renderBentoGrid = () => (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//       {/* Left */}
//       <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between">
//         <div>
//           <h3 className="text-xl font-bold text-gray-800 mb-2">
//             {selectedCourse.left.title}
//           </h3>
//           <p className="text-gray-600">{selectedCourse.left.subtitle}</p>
//         </div>
//         <img
//           src={selectedCourse.left.img}
//           alt="left"
//           className="mt-4 rounded-lg object-cover w-full h-40"
//         />
//       </div>

//       {/* Middle */}
//       <div className="flex flex-col gap-6">
//         {/* Top */}
//         <div className="bg-white rounded-xl shadow-lg p-6">
//           <h3 className="text-xl font-bold text-gray-800 mb-4">Eligibility</h3>
//           <ul className="list-disc list-inside space-y-2 text-gray-600">
//             {selectedCourse.middle.eligibility.map((item, idx) => (
//               <li key={idx}>{item}</li>
//             ))}
//           </ul>
//         </div>
//         {/* Bottom */}
//         <div className="grid grid-cols-4 gap-6 h-full">
//           {/* 25% */}
//           <div
//             className="col-span-1 bg-cover bg-center rounded-xl flex items-center justify-center text-white font-bold text-center p-4"
//             style={{
//               backgroundImage: `url(${selectedCourse.middle.bottomLeft.bg})`,
//             }}
//           >
//             {selectedCourse.middle.bottomLeft.text}
//           </div>
//           {/* 75% */}
//           <div
//             className="col-span-3 bg-cover bg-center rounded-xl p-6 text-white flex flex-col justify-between"
//             style={{
//               backgroundImage: `url(${selectedCourse.middle.bottomRight.bg})`,
//             }}
//           >
//             <h3 className="text-lg font-bold mb-3">
//               {selectedCourse.middle.bottomRight.title}
//             </h3>
//             <ul className="list-disc list-inside space-y-1">
//               {selectedCourse.middle.bottomRight.points.map((p, i) => (
//                 <li key={i}>{p}</li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Right */}
//       <div
//         className="rounded-xl shadow-lg p-6 text-white flex flex-col justify-between bg-cover bg-center"
//         style={{ backgroundImage: `url(${selectedCourse.right.bg})` }}
//       >
//         <div>
//           <h3 className="text-2xl font-bold mb-4">
//             {selectedCourse.right.title}
//           </h3>
//           <ul className="list-disc list-inside space-y-2">
//             {selectedCourse.right.points.map((item, idx) => (
//               <li key={idx}>{item}</li>
//             ))}
//           </ul>
//         </div>
//         <img
//           src={selectedCourse.right.img}
//           alt="right"
//           className="mt-4 rounded-lg object-cover w-full h-32"
//         />
//       </div>
//     </div>
//   );

//   return (
//     <section className="w-full py-16 bg-white">
//       {/* Header */}
//       <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 px-6">
//         <div className="w-full lg:w-1/2">
//           <FadeInSectionDownToUp>
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Courses That Take You Higher
//             </h2>
//           </FadeInSectionDownToUp>
//           <FadeInSectionDownToUp>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               Explore our professional pilot training programs designed to take
//               you from first flight to full certification.
//             </p>
//           </FadeInSectionDownToUp>
//         </div>
//         <div className="w-full lg:w-1/2 flex items-center justify-center">
//           <div className="relative w-full flex items-center">
//             <div className="border-t-2 border-dotted border-gray-400 w-full"></div>
//             <FaArrowRight className="absolute right-0 text-[#FF6557] text-2xl" />
//           </div>
//         </div>
//       </div>

//       {/* Course Selector */}
//       <div
//         className="py-12 px-6 bg-cover bg-center mx-5 rounded-3xl"
//         style={{
//           backgroundImage:
//             "url('https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80')",
//         }}
//       >
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {courses.map((course, index) => (
//             <FadeInSectionDownToUp key={index}>
//               <div
//                 onClick={() => handleCourseClick(course)}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full hover:scale-105 transition-transform duration-300 cursor-pointer"
//               >
//                 <img
//                   src={course.left.img}
//                   alt={course.title}
//                   className="w-full h-40 object-cover"
//                 />
//                 <div className="p-4 flex-grow flex items-center justify-center">
//                   <h3 className="text-lg font-semibold text-center text-gray-800">
//                     {course.title}
//                   </h3>
//                 </div>
//               </div>
//             </FadeInSectionDownToUp>
//           ))}
//         </div>
//       </div>

//       {/* Bento Grid (Desktop only) */}
//       <div ref={bentoRef} className="container mx-auto px-6 py-12 hidden lg:block">
//         {renderBentoGrid()}
//       </div>

//       {/* Modal (Mobile/Tablet) */}
//       {showModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto p-6 relative">
//             <button
//               className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
//               onClick={() => setShowModal(false)}
//             >
//               ✕
//             </button>
//             <h2 className="text-2xl font-bold mb-6">{selectedCourse.title}</h2>
//             {renderBentoGrid()}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default CoursesSection;




// import React, { useState } from "react";
// import { FaArrowRight } from "react-icons/fa";
// import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";

// const courses = [
//   {
//     title: "Commercial Pilot License (CPL)",
//     left: {
//       title: "10-12 Months - large",
//       subtitle: "Duration - regular",
//       img: "https://images.unsplash.com/photo-1508614999368-9260051291ea?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: [
//         "Air Regulation.",
//         "Meteorology.",
//         "Navigation.",
//         "Technical General.",
//         "RTR.",
//         "Tech Spec.",
//       ],
//       img: "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class I Medical for issue of CPL License.",
//         "10th +2 passed with Physics & Maths.",
//         "17 years of age and above at the time of joining.",
//         "Adequate competency in the English Language.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1485841890310-6a055c88698a?auto=format&fit=crop&w=600&q=80",
//         text: "Commercial Pilot License (CPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: [
//           "Single engine Flying – 185 Hrs.",
//           "Multi Engine Flying – 15 Hrs.",
//           "Simulator- 20 Hrs .",
//         ],
//       },
//     },
//   },
//   {
//     title: "Private Pilot License (PPL)",
//     left: {
//       title: "6-8 Months - medium",
//       subtitle: "Duration - flexible",
//       img: "https://images.unsplash.com/photo-1518655048521-f130df041f66?auto=format&fit=crop&w=600&q=80",
//     },
//     right: {
//       title: "Ground School",
//       points: ["Air Law.", "Human Performance.", "Flight Planning."],
//       img: "https://images.unsplash.com/photo-1508830524289-0adcbe822b40?auto=format&fit=crop&w=600&q=80",
//       bg: "https://images.unsplash.com/photo-1529070538774-1843cb3265df?auto=format&fit=crop&w=1200&q=80",
//     },
//     middle: {
//       eligibility: [
//         "DGCA Class II Medical.",
//         "10th +2 passed in any stream.",
//         "17 years and above.",
//       ],
//       bottomLeft: {
//         bg: "https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80",
//         text: "Private Pilot License (PPL)",
//       },
//       bottomRight: {
//         bg: "https://images.unsplash.com/photo-1499084732479-de2c02d45fc4?auto=format&fit=crop&w=800&q=80",
//         title: "Flying Training",
//         points: ["Single engine Flying – 40 Hrs.", "Simulator- 5 Hrs."],
//       },
//     },
//   },
// ];

// const CoursesSection = () => {
//   const [selectedCourse, setSelectedCourse] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const handleCourseClick = (course) => {
//     setSelectedCourse(course);
//     setShowModal(true); // Always open modal
//   };

//   // 🔹 Reusable Bento Grid (used inside modal)
//   const renderBentoGrid = () => (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//       {/* Left */}
//       <div className="bg-white rounded-xl shadow-lg p-6 flex flex-col justify-between">
//         <div>
//           <h3 className="text-xl font-bold text-gray-800 mb-2">
//             {selectedCourse.left.title}
//           </h3>
//           <p className="text-gray-600">{selectedCourse.left.subtitle}</p>
//         </div>
//         <img
//           src={selectedCourse.left.img}
//           alt="left"
//           className="mt-4 rounded-lg object-cover w-full h-40"
//         />
//       </div>

//       {/* Middle */}
//       <div className="flex flex-col gap-6">
//         {/* Top */}
//         <div className="bg-white rounded-xl shadow-lg p-6">
//           <h3 className="text-xl font-bold text-gray-800 mb-4">Eligibility</h3>
//           <ul className="list-disc list-inside space-y-2 text-gray-600">
//             {selectedCourse.middle.eligibility.map((item, idx) => (
//               <li key={idx}>{item}</li>
//             ))}
//           </ul>
//         </div>
//         {/* Bottom */}
//         <div className="grid grid-cols-4 gap-6 h-full">
//           {/* 25% */}
//           <div
//             className="col-span-1 bg-cover bg-center rounded-xl flex items-center justify-center text-white font-bold text-center p-4"
//             style={{
//               backgroundImage: `url(${selectedCourse.middle.bottomLeft.bg})`,
//             }}
//           >
//             {selectedCourse.middle.bottomLeft.text}
//           </div>
//           {/* 75% */}
//           <div
//             className="col-span-3 bg-cover bg-center rounded-xl p-6 text-white flex flex-col justify-between"
//             style={{
//               backgroundImage: `url(${selectedCourse.middle.bottomRight.bg})`,
//             }}
//           >
//             <h3 className="text-lg font-bold mb-3">
//               {selectedCourse.middle.bottomRight.title}
//             </h3>
//             <ul className="list-disc list-inside space-y-1">
//               {selectedCourse.middle.bottomRight.points.map((p, i) => (
//                 <li key={i}>{p}</li>
//               ))}
//             </ul>
//           </div>
//         </div>
//       </div>

//       {/* Right */}
//       <div
//         className="rounded-xl shadow-lg p-6 text-white flex flex-col justify-between bg-cover bg-center"
//         style={{ backgroundImage: `url(${selectedCourse.right.bg})` }}
//       >
//         <div>
//           <h3 className="text-2xl font-bold mb-4">
//             {selectedCourse.right.title}
//           </h3>
//           <ul className="list-disc list-inside space-y-2">
//             {selectedCourse.right.points.map((item, idx) => (
//               <li key={idx}>{item}</li>
//             ))}
//           </ul>
//         </div>
//         <img
//           src={selectedCourse.right.img}
//           alt="right"
//           className="mt-4 rounded-lg object-cover w-full h-32"
//         />
//       </div>
//     </div>
//   );

//   return (
//     <section className="w-full py-16 bg-white">
//       {/* Header */}
//       <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12 px-6">
//         <div className="w-full lg:w-1/2">
//           <FadeInSectionDownToUp>
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
//               Courses That Take You Higher
//             </h2>
//           </FadeInSectionDownToUp>
//           <FadeInSectionDownToUp>
//             <p className="text-gray-600 text-lg leading-relaxed">
//               Explore our professional pilot training programs designed to take
//               you from first flight to full certification.
//             </p>
//           </FadeInSectionDownToUp>
//         </div>
//         <div className="w-full lg:w-1/2 flex items-center justify-center">
//           <div className="relative w-full flex items-center">
//             <div className="border-t-2 border-dotted border-gray-400 w-full"></div>
//             <FaArrowRight className="absolute right-0 text-[#FF6557] text-2xl" />
//           </div>
//         </div>
//       </div>

//       {/* Course Selector */}
//       <div
//         className="py-12 px-6 bg-cover bg-center mx-5 rounded-3xl"
//         style={{
//           backgroundImage:
//             "url('https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80')",
//         }}
//       >
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
//           {courses.map((course, index) => (
//             <FadeInSectionDownToUp key={index}>
//               <div
//                 onClick={() => handleCourseClick(course)}
//                 className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col h-full hover:scale-105 transition-transform duration-300 cursor-pointer"
//               >
//                 <img
//                   src={course.left.img}
//                   alt={course.title}
//                   className="w-full h-40 object-cover"
//                 />
//                 <div className="p-4 flex-grow flex items-center justify-center">
//                   <h3 className="text-lg font-semibold text-center text-gray-800">
//                     {course.title}
//                   </h3>
//                 </div>
//               </div>
//             </FadeInSectionDownToUp>
//           ))}
//         </div>
//       </div>

//       {/* Modal (All devices) */}
//       {showModal && selectedCourse && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center px-4">
//           <div className="bg-white rounded-2xl shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6 relative">
//             <button
//               className="absolute top-3 right-3 text-gray-600 hover:text-gray-800"
//               onClick={() => setShowModal(false)}
//             >
//               ✕
//             </button>
//             <h2 className="text-2xl font-bold mb-6">{selectedCourse.title}</h2>
//             {renderBentoGrid()}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default CoursesSection;



// import { useState } from "react";
// import { Plane, Clock, BookOpen, UserCheck } from "lucide-react";

// const courses = [
//   {
//     id: "cpl",
//     title: "Commercial Pilot License (CPL)",
//     duration: "10–12 Months",
//     eligibility: [
//       "DGCA Class I Medical for issue of CPL License.",
//       "10th +2 passed with Physics & Maths.",
//       "17 years of age and above at the time of joining.",
//       "Adequate competency in the English Language.",
//     ],
//     training: [
//         "Single engine Flying – 185 Hrs (C-172,Tecnam, Diamond DA-40).",
//         "Multi Engine Flying – 15 Hrs (Piper, Diamond DA-42, Tecnam).",
//         "Simulator- 20 Hrs (Red Bird, Diamond).",
//     0],
//     ground: [
//         "Air Regulation.",
//         "Meteorology.",
//         "Navigation.",
//         "Technical General.",
//         "RTR.",
//         "Tech Spec.",
//     ],
//     image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80", // replace with actual path
//   },
//   {
//     id: "ppl",
//     title: "Private Pilot License (PPL)",
//     duration: "6–8 Months",
//     eligibility: ["Minimum 17 years old", "10th Pass", "Medical Class 2 clearance"],
//     training: "45 Hrs of Flying Training",
//     ground: "Subjects: Air Regulations, Meteorology, Air Navigation",
//     image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80",
//   },
//   {
//     id: "atpl",
//     title: "Airline Transport Pilot License (ATPL)",
//     duration: "12–15 Months",
//     eligibility: [
//       "Valid CPL",
//       "1500 Hrs Flying Experience",
//       "Medical Class 1 clearance",
//     ],
//     training: "Advanced Multi-Crew Training",
//     ground: "Subjects: Radio Aids, Air Navigation, Meteorology",
//     image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80",
//   },
//   {
//     id: "type",
//     title: "Type Rating",
//     duration: "2–3 Months",
//     eligibility: ["Valid CPL", "Medical Class 1 clearance"],
//     training: "Simulator & Aircraft Training on Specific Type",
//     ground: "Aircraft Systems, SOPs, Performance Training",
//     image: "https://images.unsplash.com/photo-1518837695005-2083093ee35b?auto=format&fit=crop&w=1920&q=80",
//   },
// ];

// export default function CourseCards() {
//   const [activeCourse, setActiveCourse] = useState(null);
//   const [activeTab, setActiveTab] = useState("eligibility");

//   return (
//     <div className="p-8 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
//       {courses.map((course) => (
//   <div
//     key={course.id}
//     className="bg-white border rounded-xl shadow-sm cursor-pointer hover:shadow-xl transition-all overflow-hidden p-5 space-y-5"
//     onClick={() => {
//       setActiveCourse(course);
//       setActiveTab("eligibility");
//     }}
//   >
//     {/* Image at top */}
//     <img
//       src={course.image}
//       alt={course.title}
//       className="w-full rounded-xl object-cover"
//     />

//     {/* Card content */}
//     <div className="flex flex-col justify-end">
//       <h3 className="text-lg font-semibold mb-2">{course.title}</h3>
//       <p className="text-sm text-gray-600 flex items-center gap-2">
//         <Clock className="w-4 h-4" /> {course.duration}
//       </p>
//     </div>
//   </div>
// ))}

//       {activeCourse && (
//         <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 relative animate-fadeIn">
//             <button
//               onClick={() => setActiveCourse(null)}
//               className="absolute top-4 right-4 text-gray-600 hover:text-black text-2xl"
//             >
//               ✕
//             </button>

//             <h2 className="text-2xl font-bold mb-4 text-blue-900">
//               {activeCourse.title}
//             </h2>
//             <p className="flex items-center gap-2 text-gray-700 font-medium mb-6">
//               <Clock className="w-5 h-5" /> {activeCourse.duration}
//             </p>

//             {/* Tabs */}
//             <div className="grid grid-cols-3 gap-2 mb-6 bg-neutral-200 p-1 rounded-lg">
//               {["eligibility", "training", "ground"].map((tab) => (
//                 <button
//                   key={tab}
//                   onClick={() => setActiveTab(tab)}
//                   className={`py-2 px-4 rounded-lg text-sm font-medium ${
//                     activeTab === tab
//                       ? "bg-blue-600 text-white"
//                       : "bg-white text-gray-700 hover:bg-gray-200"
//                   }`}
//                 >
//                   {tab === "eligibility"
//                     ? "Eligibility"
//                     : tab === "training"
//                     ? "Training"
//                     : "Ground School"}
//                 </button>
//               ))}
//             </div>

//             {/* Tab Content */}
//             {activeTab === "eligibility" && (
//               <ul className="list-disc pl-6 text-gray-700">
//                 {activeCourse.eligibility.map((item, idx) => (
//                   <li key={idx} className="mb-2 flex items-start gap-2">
//                     <UserCheck className="w-4 h-4 mt-1 text-blue-600" />
//                     {item}
//                   </li>
//                 ))}
//               </ul>
//             )}

//             {activeTab === "training" && (
//               <p className="flex items-center gap-2 text-gray-700">
//                 <Plane className="w-5 h-5 text-blue-600" /> {activeCourse.training}
//               </p>
//             )}

//             {activeTab === "ground" && (
//               <p className="flex items-center gap-2 text-gray-700">
//                 <BookOpen className="w-5 h-5 text-blue-600" /> {activeCourse.ground}
//               </p>
//             )}

//             {/* Buttons */}
//             <div className="mt-6 flex gap-4">
//               <button className="bg-blue-600 text-white rounded-xl px-6 py-2 hover:bg-blue-700">
//                 Apply Now
//               </button>
//               <button className="border border-gray-300 rounded-xl px-6 py-2 text-gray-700 hover:bg-gray-100">
//                 Download Brochure
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




import { useState } from "react";
import { Plane, Clock, BookOpen, UserCheck } from "lucide-react";
import CplFormModal from "./CplForm";

const courses = [
    {
        id: "cpl",
        title: "Commercial Pilot License (CPL)",
        duration: "10–12 Months",
        eligibility: [
            "DGCA Class I Medical for issue of CPL License.",
            "10th +2 passed with Physics & Maths.",
            "17 years of age and above at the time of joining.",
            "Adequate competency in the English Language.",
        ],
        training: [
            "Single engine Flying – 185 Hrs (C-172,Tecnam, Diamond DA-40).",
            "Multi Engine Flying – 15 Hrs (Piper, Diamond DA-42, Tecnam).",
            "Simulator – 20 Hrs (Red Bird, Diamond).",
        ],
        ground: [
            "Air Regulation.",
            "Meteorology.",
            "Navigation.",
            "Technical General.",
            "RTR.",
            "Tech Spec.",
        ],
        image:
            "https://mhcockpit.com/Media/Landing/CPL/2151983457.jpg",
    },
    {
        id: "ppl",
        title: "Private Pilot License (PPL)",
        duration: "6–8 Months",
        eligibility: [
            "Individual configuration.",
            "10th class pass from a recognised board.",
            "At least 16 years of age at the time of joining.",
            "Adequate competency in the English Language.",
        ],
        training: [
            "50 Hrs On a Single engine aircraft (C-172,DA40, Tecnam).",
            "5 Hrs of Simulator Training.",
        ],
        ground: [
            "Air Regulation.",
            "Air Navigation.",
            "Aviation Meteorology.",
            "Aircraft & Engines (General & Specific).",
        ],
        image:
            "https://mhcockpit.com/Media/Landing/CPL/51161.jpg",
    },
    {
        id: "atpl",
        title: "Airline Transport Pilot License (ATPL)",
        duration: "12–15 Months",
        eligibility: ["Valid CPL", "1500 Hrs Flying Experience", "Medical Class 1 clearance"],
        training: ["Advanced Multi-Crew Training"],
        ground: ["Radio Aids", "Air Navigation", "Meteorology"],
        image:
            "https://mhcockpit.com/Media/Landing/CPL/2151230062.jpg",
    },
    {
        id: "type",
        title: "Type Rating",
        duration: "2–3 Months",
        eligibility: ["Valid CPL", "Medical Class 1 clearance"],
        training: ["Simulator & Aircraft Training on Specific Type"],
        ground: ["Aircraft Systems", "SOPs", "Performance Training"],
        image:
            "https://mhcockpit.com/Media/Landing/CPL/intro-box-initial-type-rating-2048x1548_.jpg_webp_40cd750bba9870f18aada2478b24840a.jpg",
    },
];

export default function CourseCards() {
    const [activeCourse, setActiveCourse] = useState(null);
    const [activeTab, setActiveTab] = useState("eligibility");

    const [open, setOpen] = useState(false);

    return (
        <div className="p-8 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
            {courses.map((course) => (
                <div
                    key={course.id}
                    className="bg-white border rounded-xl shadow-sm cursor-pointer hover:shadow-xl transition-all overflow-hidden p-5 space-y-5"
                    onClick={() => {
                        setActiveCourse(course);
                        setActiveTab("eligibility");
                    }}
                >
                    {/* Image at top */}
                    <img
                        src={course.image}
                        alt={course.title}
                        className="w-full h-3/4 rounded-xl object-cover"
                    />

                    {/* Card content */}
                    <div className="flex flex-col justify-end">
                        <h3 className="text-lg font-semibold mb-2">{course.title}</h3>
                        <p className="text-sm text-gray-600 flex items-center gap-2">
                            <Clock className="w-4 h-4" /> {course.duration}
                        </p>
                    </div>
                </div>
            ))}

            {activeCourse && (
                <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl p-8 relative animate-fadeIn">
                        {/* <button
                            onClick={() => setActiveCourse(null)}
                            className="absolute top-4 right-4 text-gray-600 hover:text-black text-2xl"
                        >
                            ✕
                        </button>

                        <h2 className="text-2xl font-bold mb-4 text-blue-900">
                            {activeCourse.title}
                        </h2>
                        <p className="flex items-center gap-2 text-gray-700 font-medium mb-6">
                            <Clock className="w-5 h-5" /> {activeCourse.duration}
                        </p> */}

                        <div className="relative bg-cover bg-center rounded-xl p-6 mb-6"
                            style={{ backgroundImage: "url('https://mhcockpit.com/Media/Landing/CPL/pop-tbg.jpg')" }}>
                            <button
                                onClick={() => setActiveCourse(null)}
                                className="absolute top-4 right-4 text-white text-2xl z-50"
                            >
                                ✕
                            </button>

                            <h2 className="text-2xl font-bold text-white mb-4 drop-shadow-md">
                                {activeCourse.title}
                            </h2>
                            <p className="flex items-center gap-2 font-medium text-white mb-6 drop-shadow-md">
                                <Clock className="w-5 h-5" /> {activeCourse.duration}
                            </p>
                        </div>

                        {/* Tabs */}
                        <div className="grid grid-cols-3 gap-2 mb-6 bg-neutral-200 p-1 rounded-lg">
                            {["eligibility", "training", "ground"].map((tab) => (
                                <button
                                    key={tab}
                                    onClick={() => setActiveTab(tab)}
                                    className={`py-2 px-4 rounded-lg text-sm font-medium ${activeTab === tab
                                        ? "bg-blue-600 text-white"
                                        : "bg-white text-gray-700 hover:bg-gray-200"
                                        }`}
                                >
                                    {tab === "eligibility"
                                        ? "Eligibility"
                                        : tab === "training"
                                            ? "Training"
                                            : "Ground School"}
                                </button>
                            ))}
                        </div>

                        {/* Tab Content */}
                        {activeTab === "eligibility" && (
                            <ul className="list-disc pl-6 text-gray-700">
                                {activeCourse.eligibility.map((item, idx) => (
                                    <li key={idx} className="mb-2 flex items-start gap-2">
                                        <UserCheck className="w-4 h-4 mt-1 text-blue-600" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {activeTab === "training" && (
                            <ul className="list-disc pl-6 text-gray-700">
                                {activeCourse.training.map((item, idx) => (
                                    <li key={idx} className="mb-2 flex items-start gap-2">
                                        <Plane className="w-4 h-4 mt-1 text-blue-600" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {activeTab === "ground" && (
                            <ul className="list-disc pl-6 text-gray-700">
                                {activeCourse.ground.map((item, idx) => (
                                    <li key={idx} className="mb-2 flex items-start gap-2">
                                        <BookOpen className="w-4 h-4 mt-1 text-blue-600" />
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        )}

                        {/* Buttons */}
                        <div className="mt-6 flex gap-4">
                            <button
                                onClick={() => setOpen(true)}
                                className="bg-blue-600 text-white rounded-xl px-6 py-2 hover:bg-blue-700"
                            >
                                Apply Now
                            </button>
                            {/* <button className="border border-gray-300 rounded-xl px-6 py-2 text-gray-700 hover:bg-gray-100">
                Download Brochure
              </button> */}
                        </div>
                    </div>
                </div>
            )}

            {/* Form Modal */}
            <CplFormModal open={open} onClose={() => setOpen(false)} />
        </div>
    );
}
